module.exports = __webpack_public_path__ + "img/bottom.31ca64eb.jpg";